export default __webpack_public_path__ + "leanne.4a5adb28.png";